import React from 'react';
import {
  cn,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@ideoz/ui';

type UnsavedChangesDotProps = {
  className?: string;
  size?: 'sm' | 'md';
};

export function UnsavedChangesDot({
  className,
  size = 'md',
}: UnsavedChangesDotProps): JSX.Element {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            role="status"
            aria-label="Unsaved changes"
            className={cn(
              'inline-flex shrink-0 rounded-full bg-emerald-500 shadow-[0_0_0_2px_rgba(16,185,129,0.2)]',
              size === 'sm' ? 'size-1.5' : 'size-2',
              className,
            )}
          />
        </TooltipTrigger>
        <TooltipContent side="top">Unsaved changes</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default UnsavedChangesDot;
